export default __webpack_public_path__ + "static/media/wip.247bc8e8.svg";